<style scoped>
.slide {
    color: white;
    text-align: center;
    font-size: 6rem;
}

.button-container {
    padding-top: 10px;
    width: 50%;
    margin: 0 auto;
}
.anim {
    width: 50px;
    height: 50px;
}

.draggable-item {
    transition: all 0.3s ease;
}

.draggable-item:hover {
    transform: scale(1.05);
}

.draggable-label {
    display: block;
    position: relative;
}

.draggable-label::after {
    content: '⋮⋮';
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(255, 255, 255, 0.8);
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.draggable-item:hover .draggable-label::after {
    opacity: 1;
}

.sortable-ghost {
    opacity: 0.5;
    background: #f0f0f0;
}

.sortable-drag {
    opacity: 1;
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
    <div>
        <div class="card card-custom gutter-b bg-white border-0">
            <div class="card-header border-0 align-items-center">
                <h3 class="card-label mb-0 font-weight-bold text-body">
                    Общая информация
                </h3>
            </div>
            <div class="card-body" id="printableTable">
                <div class="row">
                    <div class="col-md-4 col-12">
                        <div class="col-12 slide-v" v-if="loadImages.length > 0">
                            <div class="slide">
                                <input :id="`inputImage-main`" @change="(event) => {changeImage(event, 0)}" type="file" name="file" accept="image/*,.heic,.heif">
                                <label
                                    :for="`inputImage-main`"
                                >
                                    <img
                                        alt="..."
                                        :src="loadImages[currentSelectedImg].link"
                                        style="width: 100%"
                                    />
                                </label>
                            </div>
                        </div>

                        <draggable
                            v-model="loadImages"
                            class="col-12 d-flex justify-content-start flex-wrap mt-3"
                            @end="onDragEnd"
                            :options="{animation: 200}"
                        >
                            <div
                                v-for="(gallary_detail, index) in loadImages"
                                :key="index"
                                class="col-2 mb-3 pl-1 pr-1 draggable-item"
                                v-if="gallary_detail != ''"
                            >
                                <input :id="`inputImages-${index}`" @change="(event) => {changeImage(event, index)}" type="file" name="file" accept="image/*,.heic,.heif">
                                <label
                                    :for="`inputImages-${index}`"
                                    class="draggable-label"
                                >
                                    <img
                                        :src="gallary_detail.link"
                                        alt="..."
                                        class="img-thumbnail"
                                        style="cursor:move;"
                                    />
                                </label>
                                <button v-if="index != currentSelectedImg" class="btn btn-block btn-danger btn-xs p-0 mt-1" @click="removeImage(index)">-</button>
                            </div>
                        </draggable>


                        <div class="col-12">
                            <hr >
                            <input id="inputImages" @change="selectImages" type="file" name="file" multiple accept="image/*,.heic,.heif">
                            <label
                                for="inputImages"
                                class="btn btn-primary cta"
                                style="width: 100%"
                            >
                                Добавить изображение(-я)
                            </label>
                            <hr >

                        </div>


                    </div>
                    <div class="col-md-8 col-12">
                        <label>Категории</label>
                        <multiselect v-model="category_id"
                                     :options="getCategories"
                                     :custom-label="nameWithLang"
                                     placeholder="Выбрать"
                                     label="name"
                                     track-by="id"
                                     :multiple="true"
                                     :taggable="true"
                                     @input="setCat"
                                     @remove='removeCat'

                        >

                        </multiselect>
                        <!-- <select
                          class="single-select w-100 mb-3 categories-select ms-offscreen"
                          multiple=""
                          style=""
                          @change="setCat($event.target.value)"
                          v-model="category_id"
                        >
                          <option value="" selected>Select Category</option>
                          <option v-for="category in categories" v-bind:value="category.id">
                            {{ category.detail == null ? "" : (category.detail[0] ? category.detail[0].name : '') }}
                          </option>
                        </select> -->
                        <small
                            class="form-text text-danger"
                            v-if="errors.has('category_id')"
                            v-text="errors.get('category_id')"
                        ></small>


                        <br />
                        <br />
                        <ul class="nav nav-pills lang-tab" id="pills-tab1" role="tablist">
                            <li
                                class="nav-item"
                                v-for="language in languages"
                                @click="setSelectedLanguage(language.id)"
                            >
                                <a
                                    class="nav-link btn-light shadow-none rounded-0"
                                    :class="language.id == selectedLanguage ? 'show active' : ''"
                                >
                                    {{ language.language_name }}
                                </a>
                            </li>
                        </ul>
                        <div class="row">

                            <div class="col-12">
                                <div class="tab-content lang-content" id="v-pills-tabContent">
                                    <div
                                        class="tab-pane fade"
                                        v-for="(language, index) in languages"
                                        :class="
                      language.id == selectedLanguage ? 'show active' : ''
                    "
                                    >
                                        <h6 class="text-body">
                                            Название товара ( {{ language.language_name }} )
                                        </h6>
                                        <fieldset class="form-group mb-3">
                                            <input
                                                type="text"
                                                :name="'name' + index"
                                                v-on:input="setTitle($event.target.value, index)"
                                                class="form-control bg-transparent text-dark"
                                                id="basicInput"
                                                v-model="title[index]"
                                                placeholder="Название"
                                            />
                                            <small
                                                class="form-text text-danger"
                                                v-if="errors.has('title')"
                                                v-text="errors.get('title')"
                                            ></small>
                                            <small
                                                class="form-text text-danger"
                                                v-if="errors.has('title.'+index)"
                                                v-text="errors.get('title.'+index)"
                                            ></small>
                                        </fieldset>
                                        <h6 class="text-body d-flex justify-content-between align-items-end">
                                            Описание ( {{ language.language_name }} ) 
                                            <button class="btn btn-primary" v-if="editMode && language.code != 'ru'" @click="translateDescription(language.code)">Автоматический перевод</button>
                                        </h6>
                                        <fieldset class="form-group mb-3">

                                            <vue-editor v-on:input="setDesc(desc[index], index)" :name="'desc' + index" v-model="desc[index]" />
                                            <small
                                                class="form-text text-danger"
                                                v-if="errors.has('desc')"
                                                v-text="errors.get('desc')"
                                            ></small>
                                            <small
                                                class="form-text text-danger"
                                                v-if="errors.has('desc.'+index)"
                                                v-text="errors.get('desc.'+index)"
                                            ></small>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-12">
                                <!--                <div class="form-group">-->
                                <!--                  <label class="text-dark">Video URL</label>-->
                                <!--                  <input-->
                                <!--                    type="text"-->
                                <!--                    v-on:input="setVideoUrl($event.target.value)"-->
                                <!--                    class="form-control" v-model="video_url"-->
                                <!--                  />-->
                                <!--                  <small-->
                                <!--                    class="form-text text-danger"-->
                                <!--                    v-if="errors.has('video_url')"-->
                                <!--                    v-text="errors.get('video_url')"-->
                                <!--                  ></small>-->
                                <!--                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-end">
                <a
                    data-toggle="pill"
                    href="#ad-info"
                    class="btn btn-primary cta"
                    @click.prevent="setActive('ad-info-tab')"
                    :class="{ active: isActive('ad-info-tab') }"
                >Продолжить</a
                >
            </div>
        </div>
        <attach-image
            @toggleImageSelect="toggleImageSelect"
            :showModal="showModal"
            @setImage="setImage"
        />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VueEditor  from "vue2-editor";
import draggable from 'vuedraggable'
export default {
    components: { Multiselect, draggable },
    data() {
        return {
            categories: [],
            languages: [],
            selectedLanguage: "",
            showModal: false,
            gallary_path: "",
            gallary_detail_path: [],
            gallary_detail_id: [],
            currentSelectedIndex: -1,
            currentSelectedImg: 0,
            currentSelectedImgClass: "",
            video_url: "",
            category_id: [],
            title: [],
            desc: [],
            loadImages: [],
        };
    },

    methods: {
        nameWithLang (option) {
            return option.detail ? `${option.detail[0].name}` : 'Hey';
        },
        getFullCategoryName(category){
            return category.parent_category ? `${this.getFullCategoryName(category.parent_category)} → ${category.detail[0].name}`: category.detail[0].name;
        },
        fetchCategories() {
            this.$parent.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/category?getAllData=1&getDetail=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.categories = res.data.data;
                    }
                })
                .finally(() => (this.$parent.$parent.loading = false));
        },
        fetchLanguages() {
            this.$parent.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/language?limit=500", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.languages = res.data.data;
                        for (var i = 0; i < res.data.data.length; i++) {
                            this.$parent.product.language_id.push(res.data.data[i].id);
                            if (res.data.data[i].is_default) {
                                this.selectedLanguage = res.data.data[i].id;
                            }
                        }
                    }
                })
                .finally(() => (this.$parent.$parent.loading = false));
        },
        setCat(value,id) {
            this.$emit("setCategoryInChild",value[value.length-1].id,'push');
        },
        removeCat(removedOption, id){
            this.$emit("setCategoryInChild",removedOption.id,'remove');
        },
        setTitle(value, index) {
            console.log(index)
            this.$emit("setTitleInChild", value, index);
        },
        setDesc(value, index) {
            this.$emit("setDescInChild", value, index);
        },
        isActive(value) {
            this.$emit("isActiveInChild", value);
        },
        setActive(value) {
            this.convertAndSave();
            this.$emit("setActiveInChild", value);
        },
        setVideoUrl(value) {
            this.$emit("setVideoUrlInChild", value);
        },

        setSelectedLanguage(selectedLanguage) {
            this.selectedLanguage = selectedLanguage;
        },
        toggleImageSelect(index = -1) {
            this.showModal = !this.showModal;
            if (index > -1) {
                this.currentSelectedIndex = index;
            }
        },
        setImage(gallary) {
            this.gallary_path = gallary.gallary_path;

            // if (this.gallary_detail_id.indexOf(gallary.gallary_id) > -1) {
            //   return;
            // }

            if (this.currentSelectedIndex > -1) {
                this.gallary_detail_path[this.currentSelectedIndex] =
                    gallary.gallary_path;
                this.gallary_detail_id[this.currentSelectedIndex] = gallary.gallary_id;
                this.currentSelectedIndex = -1;
            } else {
                this.gallary_detail_path.push(gallary.gallary_path);
                this.gallary_detail_id.push(gallary.gallary_id);
            }
            this.$emit("setGallaryIdInChild", this.gallary_detail_id);
        },
        // setSelectedImage(index) {
        //     this.currentSelectedImg = index;
        //     this.currentSelectedIndex = index;
        // },
        removeImage(index){
            this.loadImages.splice(index,1);
            this.convertAndSave()
        },
        selectImages(event){
            const files = event.target.files
            if(files.length){
                for (let i = 0; i < files.length; i++) {
                    const file = files.item(i)
                    console.log('load:', file)
                    this.$set(this.loadImages, this.loadImages.length, {
                        link: URL.createObjectURL(file),
                        item: file
                    })
                }
            }
            this.convertAndSave()
        },
        changeImage(event, index){
            const files = event.target.files;
            if(files.length){
                console.log('change')
                this.$set(this.loadImages, index, {
                    link: URL.createObjectURL(files.item(0)),
                    item: files.item(0)
                })
            }
            this.convertAndSave()
        },
        convertAndSave(){
            const fd = new FormData();
            this.loadImages.forEach(item => {
                fd.append('images[]', item.item)
            })
            this.$emit('updateImageList', fd);
        },
        onDragEnd(){
            this.convertAndSave();
        },
        translateDescription(locale_code){
            let product_id = Number(this.$route.params.id);

            var token = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            };

            axios.post(`/api/admin/product/translate-description`, {
                product_id,
                locale_code
            }, token).then(res => {
                this.$toaster.success(res.data.message);

                setTimeout(() => { window.location.reload() }, 1000);
            })
        }
    },
    watch:{
        product(newVal, oldVal){
            console.log('product')
            console.log(newVal)
            this.video_url = newVal.video_url;
            newVal.cat_id.map((cId) => {
                this.category_id.push(cId);
            });
            newVal.languages.map((item,index) => {
                this.title[index] = newVal.title_lang[index];
                this.desc[index] = newVal.desc_lang[index];
            });

            // newVal.gallary_detail_id.map((gallary_detail_id, index) => {
            //     this.gallary_detail_id.push(gallary_detail_id);
            // });
            //
            // newVal.gallary_detail_path.map((gallary_detail_path_single, index) => {
            //     this.gallary_detail_path.push(gallary_detail_path_single);
            // });

            const imagePromises = newVal.images.map((image, index) => {
                return fetch(image.original.replace('http://','https://'))
                    .then(response => response.blob())
                    .then(imageBlob => {
                        let filename = image.original.split('/');
                        const myFile = new File([imageBlob], filename[filename.length -1], {
                            type: imageBlob.type,
                        });
                        return {
                            link: URL.createObjectURL(imageBlob),
                            item: myFile,
                            order: parseInt(filename[filename.length -2]),
                            index: index
                        };
                    });
            });

            Promise.all(imagePromises).then(images => {
                images.sort((a, b) => a.order - b.order);
                this.loadImages = images;
                console.log('All images loaded:', this.loadImages.length);
                // Auto-save images for copy mode
                if (this.$parent.copy) {
                    this.convertAndSave();
                }
            });
        }
    },
    mounted() {
        this.fetchCategories();
        this.fetchLanguages();

    },
    computed: {
      getCategories(){
          return this.categories.map((item) => {
              item.detail[0].name = this.getFullCategoryName(item);
              return item;
          })
      },
      editMode(){
        return this.$route.params.hasOwnProperty('id');
      }
    },
    props: ["product", "errors", 'edit'],
};
</script>
